'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './initiativeVideo.routes';

export class InitiativeVideoComponent {
    /*@ngInject*/
    constructor($anchorScroll, searchService, $state, $window, $location, $http, $scope) {
        this.message = 'Hello';
        this.$anchorScroll = $anchorScroll;
        this.searchService = searchService;
        this.$state = $state;
        this.$window = $window;
        this.$location = $location;
        this.$http = $http;
        this.$scope = $scope;
        this.message = 'Hello';
    }

    $onInit() {
        var key;
        this.$anchorScroll;
        this.$scope.baseURL = this.searchService.getBaseURL();
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        //Get Copyright
        this.getCopyright('UCTV');

        //Check if key exists in service
        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            this.hasKey = true;
            this.key = key;
        } else if (this.$location.search().key) {
            key = this.$location.search().key;
            this.key = key;
            this.hasKey = true;
        } else {
            this.hasKey = false;
        }

        //If no key exists in url, add parameter
        if (!this.$location.search().key) {
            console.log(key);

            this.$location.search('key', key);
        }

        if (!this.searchService.getKey()) {
            this.searchService.setKey(key);
        }

        console.log(key);

        //Check key for nav access
        this.$http.get(`${this.$scope.baseURL}/api/cw/client/${key}`)
            .then(response => {
                this.$scope.client = response.data[0];
                console.log("the client is: ", this.$scope.client);
                this.getInitiative();
            })
            .catch(err => {
                console.log(err);
            });

    }

    getInitiative(){
        this.initiative = this.searchService.getInitiative();

        console.log(this.initiative);
        console.log(this.$location.search());
    if (!this.$location.search().id && this.initiative.uuid) {
        console.log('adding location id', this.initiative.uuid);
        this.$location.search('id', this.initiative.uuid).replace();

    }

    if (this.$location.search().id) {
        this.$http.get(`${this.$scope.baseURL}/api/initiatives/${this.$location.search().id}/${this.key}`)
            .then(response => {
                this.initiative = response.data[0];
                // $('.initiative-content').html(this.initiative.html);
                // $('.video-description').html(this.initiative.description);
                // $('.subtitle-description').html(this.initiative.subtitleDescription);
                console.log(this.initiative);

                if (this.$scope.client.uctvVideoType === 'youtube') {
                    $('.video-content').html(this.initiative.htmlYouTube);
                    $('.video-description').html(this.initiative.description);
                    $('.subtitle-description').html(this.initiative.subtitleDescription);
                    if (this.initiative.updateDate) {
                        $('.video-updateDate').html(`Updated: ${this.initiative.updateDate}`);
                    }
                } else {
                    $('.video-content').html(this.initiative.html);
                    $('.video-description').html(this.initiative.description);
                    if (this.initiative.updateDate) {
                        $('.video-updateDate').html(`Updated: ${this.initiative.updateDate}`);
                    }
                    $('.subtitle-description').html("");
                }

                if (this.initiative.relatedInitiative) {
                    console.log(JSON.parse(this.initiative.relatedInitiative));
                    this.relatedInitiatives = JSON.parse(this.initiative.relatedInitiative);
                    console.log("related initiaitives: ", this.relatedInitiatives);
                }

                if (this.initiative.relatedVideo) {
                    console.log(JSON.parse(this.initiative.relatedInitiative));
                    this.relatedVideos = JSON.parse(this.initiative.relatedVideo);
                }

                if (this.initiative.relatedArticle) {
                    this.relatedArticles = JSON.parse(this.initiative.relatedArticle);
                }




            })
            .catch(err => {
                console.log(err);
            })
    } else {
        // this.$state.go('main');
    }
    }

    getCopyright(type) {
        //Get Copyright
        var key;
        this.$http.get(`${this.$scope.baseURL}/api/data/copyright/${type}`)
            .then(response => {
                this.$scope.copyrightCW = response.data[0].copyright;
            })
            .catch(err => {
                console.log(err);
            })
    }

    print() {
        this.$window.print();
    }

    backToResults() {
        this.$window.history.back(-2);
        
    }

    goHome() {
        this.$state.go('main');
    }

    loadRelatedInitiative(data) {
        this.$anchorScroll();
        console.log(data);
        this.$http.get(`${this.$scope.baseURL}/api/initiatives/${data.uuid}/${this.key}`)
            .then(response => {
                console.log(response.data);
                this.initiative = response.data;
                $('.initiative-content').html(this.initiative.html);
                console.log(this.initiative);
                console.log(JSON.parse(this.initiative.initiativeTags));
                if (this.initiative.relatedInitiative) {
                    console.log(JSON.parse(this.initiative.relatedInitiative));
                    this.relatedInitiatives = JSON.parse(this.initiative.relatedInitiative);
                }

            })
            .catch(err => {
                console.log(err);
            })
    }
}

export default angular.module('webApp.initiativeVideo', [uiRouter])
    .config(routes)
    .component('initiativeVideo', {
        template: require('./initiativeVideo.html'),
        controller: InitiativeVideoComponent,
        controllerAs: 'initiativeVideoCtrl'
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/initiativeVideo/initiativeVideo.component.js